import { Language } from "@/store/user-config-store";

/**
 * Maps a {@link Language} to a BCP 47 locale string usable with the `Intl` APIs
 * (e.g. `Intl.DateTimeFormat`, `Intl.NumberFormat`).
 */
export function getLanguageLocale(language: Language): string {
  return language === Language.English ? "en-US" : "de-DE";
}
